import { registerPlugin } from '@capacitor/core';
const StockfishVariants = registerPlugin('StockfishVariants');
export * from './definitions';
export { StockfishVariants };
//# sourceMappingURL=index.js.map